<template>
	<v-row v-bind="$attrs" dense class="text-body-2">
		<v-card
			dark
			color="primary"
			class="px-2 mr-1"
			v-for="total in totaisPorGrauOrdenados"
			:key="total.sigla"
		>
			{{ total.valor }} {{ total.sigla }}
		</v-card>
		<v-card
			dark
			color="primary darken-2"
			class="px-2 font-weight-bold"
		>
			{{ totais
				? Object
					.values(totais)
					.reduce((soma, quantidade) => soma + quantidade, 0)
				: 0
			}} IIr
		</v-card>
	</v-row>
</template>

<script setup lang="ts">
import { computed, PropType } from 'vue'
import { TotalDeGrau, totaisPorGrauOrdenados as ordenarTotaisPorGrau } from '../shareds'

const props = defineProps({
	totais: { type: Object as PropType<TotalDeGrau> },
})

const totaisPorGrauOrdenados = computed(() => ordenarTotaisPorGrau(props.totais))
</script>
